import axios, { AxiosResponse } from 'axios';
import { getUri } from './uri';
import { MappedType } from '../typings/mappedType';
import { AuthService } from '../services/Auth/AuthService';

export async function request<T = any>(query: string, variables: MappedType = {}): Promise<AxiosResponse<T>['data']> {
  const apiUrl = getUri(window.location.hostname);

  const token = AuthService.getToken();
  const headers = {
    system: 'Content',
    'content-type': 'application/json',
    ...(token && { authorization: `Bearer ${token}` }),
  };

  return (await axios({
    url: apiUrl,
    method: 'POST',
    data: {
      query,
      ...(variables && { variables }),
    },
    headers,
  })).data;
}
